// extracted by mini-css-extract-plugin
module.exports = {"uploadFileStubContainer":"UploadFileStub_uploadFileStubContainer__2yw7v","stubInputWrapper":"UploadFileStub_stubInputWrapper__3aasq","label":"UploadFileStub_label__1CYAp"};